import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    wrapper: {
        padding: '2rem 1rem 2rem 1rem',
        backgroundColor:"white",
        borderRadius:"10px"
    },
    header: {
        padding: "10px 20px",
    },
    toolbar: {
        padding: "10px 20px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    crudButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    content: {
        padding: "10px 20px",
    },
    contentHeader: {
        padding: "10px 20px",
        marginBottom: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        overflowX: 'auto'
    },
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
      },
      graphContainer: {
        height: 310,
        position: "relative",
      },
      selectHeader: {
        // marginBottom: "1rem",
        padding: "2rem 1rem 0 1rem",
      },
      noDataMessage: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      },
      toggleWrapper: {
        display: "inline-flex",
        justifyContent: "start",
      },
}));